// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Rejection Modal Specific Styles */
.reject_complaint_rejectModal__luiDi {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}



.reject_complaint_selectInput__Jejn0{
  width: 100%;
}

.reject_complaint_rejectModalContent__\\+uonm {
  background-color: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  overflow: hidden;
}

.reject_complaint_forwardModalContent__xO6JG{
    background-color: white;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
}

.reject_complaint_rejectModalHeader__YCU1M {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.reject_complaint_rejectModalTitle__gYGW8 {
  color: var(--Slate-700, #334155);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
}

.reject_complaint_rejectCloseButton__BTXr6 {
  color: #6b7280;
}

.reject_complaint_rejectCloseButton__BTXr6:hover {
  background-color: #f3f4f6;
}

.reject_complaint_rejectModalBody__5EBeX {
  padding: 24px;
}

.reject_complaint_rejectConfirmationText__kRgmv {
  color: var(--Slate-800, #1e293b);

  /* Inter/Body md/Body md - semibold */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
}

.reject_complaint_rejectWarningText__PNoVi {
  color: var(--Slate-500, #64748b);

  /* text-sm/leading-5/normal */
  font-family: var(--font-family-font-sans, Inter);
  font-size: text-sm;
  font-style: normal;
  font-weight: var(--font-weight-font-normal, 400);
  line-height: leading-5; /* 142.857% */
  margin-bottom: 16px;
}

.reject_complaint_rejectRemarkSection__nJbU7 {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.reject_complaint_rejectRemarkLabel__zWsOh {
  color: var(--Gray-800, #1f2937);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 8px;
}

.reject_complaint_rejectRemarkTextarea__vECik {
  width: 100%;
  min-height: 140px;
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  resize: vertical;
  outline: none;
  position: relative;
  /* z-index: 1600; */
}

.reject_complaint_rejectModalFooter__bCqa5 {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 16px 24px 24px 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #fff;
}

.reject_complaint_rejectCancelButton__Cs5Et {
  /* border: 1px solid #d1d5db; */
  color: #374151;
  text-transform: none;
  font-weight: 500;
  padding: 7px 24px;
  border-radius: 8px;
  background-color: rgba(241, 245, 249, 1);
  min-width: 100px;
}

.reject_complaint_rejectCancelButton__Cs5Et:hover {
  border-color: #9ca3af;
  background-color: #f3f4f6;
}

.reject_complaint_rejectConfirmButton__X3Pts {
  background-color: rgba(220, 38, 38, 1);
  text-transform: none;
  font-weight: 500;
  padding: 7px 24px;
  border-radius: 8px;
  color: white;
  min-width: 100px;
}

.reject_complaint_holdConfirmButton__kIY23 {
  background-color: #644ee5;
  text-transform: none;
  font-weight: 500;
  padding: 7px 24px;
  border-radius: 8px;
  color: white;
  min-width: 100px;
}

.reject_complaint_holdConfirmButton__kIY23:hover {
  background-color: #4f46e5;
}

.reject_complaint_rejectConfirmButton__X3Pts:hover {
  background-color: #b91c1c;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .reject_complaint_deleteModal__ESbex .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  .reject_complaint_modalActions__r7cC2 {
    padding: 8px 16px 16px 16px !important;
    gap: 12px !important;
  }

  .reject_complaint_cancelButton__CXUG2,
  .reject_complaint_deleteButton__n3XZu {
    padding: 10px 20px !important;
  }
}

/* -------------------------------------- */
/*  RESPONSIVE REJECT MODAL IMPROVEMENTS  */
/* -------------------------------------- */

/* Tablet */
@media (max-width: 1024px) {
  .reject_complaint_rejectModalContent__\\+uonm {
    max-width: 60%;
  }
}

/* Mobile Landscape / Small Tablets */
@media (max-width: 768px) {
  .reject_complaint_rejectModal__luiDi {
    padding: 12px;
  }

  .reject_complaint_rejectModalContent__\\+uonm {
    max-width: 70%;
    width: 100%;
    border-radius: 10px;
  }

  .reject_complaint_rejectModalHeader__YCU1M,
  .reject_complaint_rejectModalBody__5EBeX,
  .reject_complaint_rejectModalFooter__bCqa5 {
    padding: 16px;
  }

  .reject_complaint_rejectModalTitle__gYGW8 {
    font-size: 18px;
  }

  .reject_complaint_rejectConfirmationText__kRgmv {
    font-size: 15px;
  }

  .reject_complaint_rejectRemarkTextarea__vECik {
    min-height: 120px;
    font-size: 13px;
  }

  .reject_complaint_rejectCancelButton__Cs5Et,
  .reject_complaint_rejectConfirmButton__X3Pts {
    padding: 8px 16px;
    font-size: 14px;
    min-width: 90px;
  }
  .reject_complaint_deleteModal__ESbex .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  .reject_complaint_modalActions__r7cC2 {
    padding: 8px 16px 16px 16px !important;
    gap: 12px !important;
  }

  .reject_complaint_cancelButton__CXUG2,
  .reject_complaint_deleteButton__n3XZu {
    padding: 10px 20px !important;
  }
}

/* Mobile Portrait */
@media (max-width: 480px) {
  .reject_complaint_rejectModal__luiDi {
    padding: 8px;
  }

  .reject_complaint_rejectModalContent__\\+uonm {
    max-width: 100%;
    width: 100%;
    border-radius: 8px;
    margin: 10px;
  }

  .reject_complaint_rejectModalHeader__YCU1M {
    padding: 14px 16px;
  }

  .reject_complaint_rejectModalTitle__gYGW8 {
    font-size: 17px;
  }

  .reject_complaint_rejectModalBody__5EBeX {
    padding: 16px;
  }

  .reject_complaint_rejectConfirmationText__kRgmv {
    font-size: 14px;
    line-height: 20px;
  }

  .reject_complaint_rejectRemarkLabel__zWsOh {
    font-size: 13px;
  }

  .reject_complaint_rejectRemarkTextarea__vECik {
    min-height: 100px;
    padding: 10px;
    font-size: 13px;
  }

  .reject_complaint_rejectModalFooter__bCqa5 {
    flex-direction: column-reverse;
    gap: 10px;
    padding: 12px;
  }

  .reject_complaint_rejectCancelButton__Cs5Et,
  .reject_complaint_rejectConfirmButton__X3Pts {
    width: 100%;
    padding: 10px;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminDashboard/Hospital_Complaint/components/reject_complaint.module.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;;;AAIA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;IACI,uBAAuB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;;EAEhC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,gCAAgC;;EAEhC,6BAA6B;EAC7B,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB,EAAE,aAAa;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA,2CAA2C;AAC3C,2CAA2C;AAC3C,2CAA2C;;AAE3C,WAAW;AACX;EACE;IACE,cAAc;EAChB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["/* Rejection Modal Specific Styles */\n.rejectModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n}\n\n\n\n.selectInput{\n  width: 100%;\n}\n\n.rejectModalContent {\n  background-color: white;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.forwardModalContent{\n    background-color: white;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.rejectModalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.rejectModalTitle {\n  color: var(--Slate-700, #334155);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n}\n\n.rejectCloseButton {\n  color: #6b7280;\n}\n\n.rejectCloseButton:hover {\n  background-color: #f3f4f6;\n}\n\n.rejectModalBody {\n  padding: 24px;\n}\n\n.rejectConfirmationText {\n  color: var(--Slate-800, #1e293b);\n\n  /* Inter/Body md/Body md - semibold */\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n}\n\n.rejectWarningText {\n  color: var(--Slate-500, #64748b);\n\n  /* text-sm/leading-5/normal */\n  font-family: var(--font-family-font-sans, Inter);\n  font-size: text-sm;\n  font-style: normal;\n  font-weight: var(--font-weight-font-normal, 400);\n  line-height: leading-5; /* 142.857% */\n  margin-bottom: 16px;\n}\n\n.rejectRemarkSection {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.rejectRemarkLabel {\n  color: var(--Gray-800, #1f2937);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n\n.rejectRemarkTextarea {\n  width: 100%;\n  min-height: 140px;\n  padding: 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-family: Inter, sans-serif;\n  font-size: 14px;\n  resize: vertical;\n  outline: none;\n  position: relative;\n  /* z-index: 1600; */\n}\n\n.rejectModalFooter {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding: 16px 24px 24px 24px;\n  border-top: 1px solid #e5e7eb;\n  background-color: #fff;\n}\n\n.rejectCancelButton {\n  /* border: 1px solid #d1d5db; */\n  color: #374151;\n  text-transform: none;\n  font-weight: 500;\n  padding: 7px 24px;\n  border-radius: 8px;\n  background-color: rgba(241, 245, 249, 1);\n  min-width: 100px;\n}\n\n.rejectCancelButton:hover {\n  border-color: #9ca3af;\n  background-color: #f3f4f6;\n}\n\n.rejectConfirmButton {\n  background-color: rgba(220, 38, 38, 1);\n  text-transform: none;\n  font-weight: 500;\n  padding: 7px 24px;\n  border-radius: 8px;\n  color: white;\n  min-width: 100px;\n}\n\n.holdConfirmButton {\n  background-color: #644ee5;\n  text-transform: none;\n  font-weight: 500;\n  padding: 7px 24px;\n  border-radius: 8px;\n  color: white;\n  min-width: 100px;\n}\n\n.holdConfirmButton:hover {\n  background-color: #4f46e5;\n}\n\n.rejectConfirmButton:hover {\n  background-color: #b91c1c;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .deleteModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  .modalActions {\n    padding: 8px 16px 16px 16px !important;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .deleteButton {\n    padding: 10px 20px !important;\n  }\n}\n\n/* -------------------------------------- */\n/*  RESPONSIVE REJECT MODAL IMPROVEMENTS  */\n/* -------------------------------------- */\n\n/* Tablet */\n@media (max-width: 1024px) {\n  .rejectModalContent {\n    max-width: 60%;\n  }\n}\n\n/* Mobile Landscape / Small Tablets */\n@media (max-width: 768px) {\n  .rejectModal {\n    padding: 12px;\n  }\n\n  .rejectModalContent {\n    max-width: 70%;\n    width: 100%;\n    border-radius: 10px;\n  }\n\n  .rejectModalHeader,\n  .rejectModalBody,\n  .rejectModalFooter {\n    padding: 16px;\n  }\n\n  .rejectModalTitle {\n    font-size: 18px;\n  }\n\n  .rejectConfirmationText {\n    font-size: 15px;\n  }\n\n  .rejectRemarkTextarea {\n    min-height: 120px;\n    font-size: 13px;\n  }\n\n  .rejectCancelButton,\n  .rejectConfirmButton {\n    padding: 8px 16px;\n    font-size: 14px;\n    min-width: 90px;\n  }\n  .deleteModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  .modalActions {\n    padding: 8px 16px 16px 16px !important;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .deleteButton {\n    padding: 10px 20px !important;\n  }\n}\n\n/* Mobile Portrait */\n@media (max-width: 480px) {\n  .rejectModal {\n    padding: 8px;\n  }\n\n  .rejectModalContent {\n    max-width: 100%;\n    width: 100%;\n    border-radius: 8px;\n    margin: 10px;\n  }\n\n  .rejectModalHeader {\n    padding: 14px 16px;\n  }\n\n  .rejectModalTitle {\n    font-size: 17px;\n  }\n\n  .rejectModalBody {\n    padding: 16px;\n  }\n\n  .rejectConfirmationText {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .rejectRemarkLabel {\n    font-size: 13px;\n  }\n\n  .rejectRemarkTextarea {\n    min-height: 100px;\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .rejectModalFooter {\n    flex-direction: column-reverse;\n    gap: 10px;\n    padding: 12px;\n  }\n\n  .rejectCancelButton,\n  .rejectConfirmButton {\n    width: 100%;\n    padding: 10px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rejectModal": `reject_complaint_rejectModal__luiDi`,
	"selectInput": `reject_complaint_selectInput__Jejn0`,
	"rejectModalContent": `reject_complaint_rejectModalContent__+uonm`,
	"forwardModalContent": `reject_complaint_forwardModalContent__xO6JG`,
	"rejectModalHeader": `reject_complaint_rejectModalHeader__YCU1M`,
	"rejectModalTitle": `reject_complaint_rejectModalTitle__gYGW8`,
	"rejectCloseButton": `reject_complaint_rejectCloseButton__BTXr6`,
	"rejectModalBody": `reject_complaint_rejectModalBody__5EBeX`,
	"rejectConfirmationText": `reject_complaint_rejectConfirmationText__kRgmv`,
	"rejectWarningText": `reject_complaint_rejectWarningText__PNoVi`,
	"rejectRemarkSection": `reject_complaint_rejectRemarkSection__nJbU7`,
	"rejectRemarkLabel": `reject_complaint_rejectRemarkLabel__zWsOh`,
	"rejectRemarkTextarea": `reject_complaint_rejectRemarkTextarea__vECik`,
	"rejectModalFooter": `reject_complaint_rejectModalFooter__bCqa5`,
	"rejectCancelButton": `reject_complaint_rejectCancelButton__Cs5Et`,
	"rejectConfirmButton": `reject_complaint_rejectConfirmButton__X3Pts`,
	"holdConfirmButton": `reject_complaint_holdConfirmButton__kIY23`,
	"deleteModal": `reject_complaint_deleteModal__ESbex`,
	"modalActions": `reject_complaint_modalActions__r7cC2`,
	"cancelButton": `reject_complaint_cancelButton__CXUG2`,
	"deleteButton": `reject_complaint_deleteButton__n3XZu`
};
export default ___CSS_LOADER_EXPORT___;
